import { gql } from "@apollo/client";

export const FetchAppRolesQuery = gql`
  query FetchAppRoles {
    appRoles {
      id
      identifier
      displayName
      description
      assignees {
        azureObjectId
        name
        members {
          id
          name
        }
      }
    }
  }
`;

export const FetchGroupsQuery = gql`
  query FetchGroups {
    groups {
      prsGroupId
      azureObjectId
      name
      members {
        id
        name
      }
    }
  }
`;

export const FetchUsersQuery = gql`
  query FetchUsers {
    users {
      id
      name
      groups
    }
  }
`;

export const FetchStoragePermissionsQuery = gql`
  query FetchStoragePermissions {
    storagePermissions {
      storageName
      isError
      errorMessage
      roleResults {
        roleName
        principalDisplayNames
      }
    }
  }
`;
